import { type AxiosRequestConfig, getApiClient } from 'apiClient';
import { routes } from './routes';

type BodyRequest = FormData;

type UploadedChunkResponse = {
  ETag: string;
};

export const uploadChunk = async ({
  body,
  config,
  mediaId,
}: {
  body: BodyRequest;
  config: AxiosRequestConfig & {
    headers: {
      'Content-Type': 'multipart/form-data';
    };
  };
  mediaId: string;
}) => getApiClient().put<UploadedChunkResponse>(routes.chunkedUpload.chunk.upload(mediaId), body, config);
